<template>
    <div id="settingsList" class="wrapper">
        <div class="row relative">
            <div class="settings-menu">
                <div class="column">

                    <section v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().WebPushSettings.id) ||
                             requiresRight(this.$parleyAdmin.auth.getRightsList().AndroidPushSettings.id) ||
                             requiresRight(this.$parleyAdmin.auth.getRightsList().iOSPushSettings.id) ||
                             requiresRight(this.$parleyAdmin.auth.getRightsList().ManageOfficeHours.id)">
                        <div class="row separator">
                            <p>Configuration</p>
                        </div>
                        <settings-bar-menu-item v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().WebPushSettings.id) ||
                                requiresRight(this.$parleyAdmin.auth.getRightsList().AndroidPushSettings.id) ||
                                requiresRight(this.$parleyAdmin.auth.getRightsList().iOSPushSettings.id)"
                                title="Push notifications" icon="notifications_none" :route="settingsPush"/>
                        <settings-bar-menu-item v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().ManageOfficeHours.id)"
                                title="Office hours" icon="access_time" :route="settingsOfficeHours"/>
                        <settings-bar-menu-item v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().ManageOfficeHours.id)"
                                title="Special messages" icon="feedback" :route="settingsSpecialMessages"/>
                    </section>

                    <section v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().UpdateDesignSettings.id)">
                        <div class="row separator">
                            <p>Mobile Appearance</p>
                        </div>
                        <settings-bar-menu-item title="Mobile colors" icon="colorize" :route="settingsAppearance"/>
                        <settings-bar-menu-item title="Mobile settings" icon="mail_outline" :route="settingsMessenger"/>
                    </section>

                    <section v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().GetSharedSecret.id) ||
                                requiresRight(this.$parleyAdmin.auth.getRightsList().AuthorizationHeadersSettings.id) ||
                                requiresRight(this.$parleyAdmin.auth.getRightsList().AuthorizationHeaderGenerateAndValidate.id)"
                    >
                        <div class="row separator">
                            <p>Security</p>
                        </div>

                        <settings-bar-menu-item title="Authorization" icon="security" :route="settingsAuthorization"/>
                    </section>

                    <section v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().ManageServices.id)">
                        <div class="row separator">
                            <p>Service</p>
                        </div>

                        <settings-bar-menu-item title="Service information" icon="cloud_circle" :route="settingsService"/>
                    </section>

                    <section v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().ManageDataretention.id)">
                        <div class="row separator">
                            <p>Policies</p>
                        </div>

                        <settings-bar-menu-item title="Data Retention" icon="folder_shared" :route="settingsDataRetention"/>
                    </section>

                    <div class="row separator">
                        <p>Help center</p>
                    </div>

                    <settings-bar-menu-item title="Library Docs" icon="library_books" :route="settingsLibraryDocs"/>

                    <settings-bar-menu-item title="Api Docs" icon="cloud_queue" :route="settingsApiDocs"/>

                    <settings-bar-menu-item title="Demo page" icon="visibility" :route="settingsDemoPage"/>
                </div>
            </div>
            <div class="col content">
                <router-view :libraryVersion="libraryVersion" :key="libraryVersion"/>
            </div>
        </div>
    </div>
</template>


<script>
import { Default } from '@/mixins/mixins';
import settingsBarMenuItem from './additional/settingsBarMenuItem';

export default {
    name: 'settings',
    mixins: [
        Default
    ],
    components: {
        settingsBarMenuItem,
    },
    data() {
        return {
            // Account identification
            identification: '',
            // Settings
            settingsGeneral: '',
            settingsAuthorization: '',
            settingsLibraryDocs: '',
            settingsApiDocs: '',
            settingsOfficeHours: '',
            settingsDataRetention: '',
            // Other
            libraryVersion: this.$parleyAdmin.libraryVersion,
            selectedRoute: this.settingsGeneral
        };
    },
    created() {
        this.identification = this.$store.getters[this.$store.types.loggedinAccount.getters.get].identification;
        this.settingsGeneral = {name: 'settingsGeneral', params: {'identification': this.identification, callback: this.callback}};
        this.settingsAppearance = {name: 'appearance', params: {'identification': this.identification, callback: this.callback}};
        this.settingsMessenger = {name: 'messenger', params: {'identification': this.identification, callback: this.callback}};
        this.settingsPush = {name: 'settingsPush', params: {'identification': this.identification, callback: this.callback}};
        this.settingsOfficeHours = {name: 'settingsOfficeHours', params: {'identification': this.identification, callback: this.callback}};
        this.settingsSpecialMessages = {name: 'settingsSpecialMessages', params: {'identification': this.identification, callback: this.callback}};
        this.settingsAuthorization = {name: 'settingsAuthorization', params: {'identification': this.identification, callback: this.callback}};
        this.settingsLibraryDocs = {name: 'settingsLibraryDocs', params: {'identification': this.identification, callback: this.callback}};
        this.settingsApiDocs = {name: 'settingsApiDocs', query: {callback: this.callback}};
        this.settingsDemoPage = {name: 'settingsDemoPage', query: {callback: this.callback}};
        this.settingsDataRetention = {name: 'settingsDataRetention', params: {'identification': this.identification, callback: this.callback}};
        this.settingsService = {name: 'settingsService', params: {'identification': this.identification, callback: this.callback}};

        // Route to last path IF last path is a path within the settings children
        // and the we are not already on the page
        if (this.lastPath.fullPath && this.lastPath.fullPath !== this.$route.path) {
            const mainRoute = this.$router.options.routes[0];
            const thisRoute = mainRoute.children.filter((child) => child.name === 'settings')[0]; // 'settings' is the name of the route this page is in and it holds all other settingsXXX.vue pages as children

            const filter = thisRoute.children.filter((route) => route.name === this.lastPath.name);
            if (filter.length > 0)
                return this.$router.push(this.lastPath.fullPath);
        }
    },
    mounted() {
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .settings-menu {
        width: 400px;
        /*padding-top: 20px;*/
        height: calc(100vh - 62px);
        overflow-y: auto;
        .menu-item {
            padding: 15px 30px;
            font-size: 16px;
            color: #454D5A;

            &:hover {
                background-color: #D6DCE6;
                transition: background-color 0.1s;
            }

            i {
                padding: 0 35px 0 15px;
            }
        }

        .separator {
            padding: 15px 25px;

            p {
                font-size: 14px;
                color: #A1A5B5;
                font-weight: 500;
            }
        }
    }

    .relative {
        position: relative;
    }

    .content {
        padding: 30px 40px 30px 40px;
        background-color: white;
        height: calc(100vh - 66px);
        overflow: auto;
    }
</style>
